<template>
	<div></div>
</template>

<script>
export default {
	created() {
		this.$store.commit(
			'setLanguage',
			navigator.language.slice(0, 2) === 'ja' ? 'ja' : 'ko',
		)

		if (this.$store.getters['language'] === 'ko') {
			window.location.replace('https://tella.co.kr')
		} else {
			this.$router.push({
				name: 'Landing',
				params: { language: this.$store.getters['language'] },
			})
		}
	},
}
</script>

<style lang="scss" scoped></style>
